import { Button, Group, Modal, Tooltip } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useNavigate } from 'react-router-dom'

import useAuth from '../hooks/api/useAuth'

function LogoutButton() {
  const { signOut } = useAuth()
  const [opened, { open, close }] = useDisclosure(false)
  const navigate = useNavigate()

  const handleSignOut = () => {
    signOut()
    return navigate('/login')
  }

  return (
    <>
      {/* <button type='button' className='flex items-center bg-transparent text-white' onClick={open}> */}
      <Tooltip label='ログアウト'>
        <button type='button' className='flex items-center bg-transparent' onClick={open}>
          <span className='material-icons text-2xl pr-4 text-tgr-orange'>logout</span>
          {/* <span className='material-icons text-2xl pr-4'>logout</span>ログアウト */}
        </button>
      </Tooltip>

      <Modal size='sm' opened={opened} onClose={close} withCloseButton={false} centered>
        <div className='flex flex-col items-center'>
          <div className='p-4'>ログアウトしますか？</div>
          <Group>
            <Button color='#001E61' onClick={handleSignOut}>
              はい
            </Button>
            <button type='button' className='text-[#001E61] font-semibold' onClick={close}>
              キャンセル
            </button>
          </Group>
        </div>
      </Modal>
    </>
  )
}

export default LogoutButton
